import React, { Fragment } from 'react'

import useFeatureFlags from '~/hooks/use-feature-flags'

import Checkbox from './partials/checkbox'
import Note from './partials/note'

import type { CartState } from '~/types'

import './index.scss'

type Props = {
  cart: CartState
  onChange: (arg0: boolean) => void
  save: boolean
  className?: string
}

export default function SaveCardOnFile(props: Props) {
  const { saveCadCardsOnFileEnabled } = useFeatureFlags()

  const cannotSaveCardOnFile = () => {
    if (saveCadCardsOnFileEnabled) {
      return (
        props.cart.payloadCurrency === 'CAD' &&
        props.cart.purchaseGroup === 'default'
      )
    } else {
      return props.cart.payloadCurrency === 'CAD'
    }
  }

  if (cannotSaveCardOnFile()) return null

  return (
    <Fragment>
      <Checkbox
        onChange={props.onChange}
        checked={props.save}
        className={props.className}
      />
      <Note creditCard={props.cart.creditCard} />
    </Fragment>
  )
}
